"use client"

import { Button } from "@/components/ui/button"
import { Facebook, Instagram, Linkedin, Youtube, MapPin, Phone, Mail } from "lucide-react"

export function MVFooter() {
  return (
    <footer className="bg-[#0a2647] text-[#e0f2fe]">
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <img src="/images/verma.webp" alt="MV Tutorials" width="60" height="60" />
              <div>
                <h3 className="font-serif text-lg sm:text-xl font-bold text-white">M.V. Tutorials</h3>
                <p className="text-xs sm:text-sm text-slate-200">Verma Group of Institution</p>
              </div>
            </div>
            <p className="text-slate-200 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
              Premier coaching institute guiding students through board, competitive, and professional entrance exams with personalised attention.
            </p>
            <div className="flex gap-2 sm:gap-4">
              <Button size="sm" variant="ghost" className="text-slate-100 hover:bg-slate-100/10 p-2">
                <Facebook className="h-4 w-4" />
              </Button>
              <Button size="sm" variant="ghost" className="text-slate-100 hover:bg-slate-100/10 p-2">
                <Instagram className="h-4 w-4" />
              </Button>
              <Button size="sm" variant="ghost" className="text-slate-100 hover:bg-slate-100/10 p-2">
                <Linkedin className="h-4 w-4" />
              </Button>
              <Button size="sm" variant="ghost" className="text-slate-100 hover:bg-slate-100/10 p-2">
                <Youtube className="h-4 w-4" />
              </Button>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 sm:mb-6 text-base sm:text-lg">Programs</h4>
            <ul className="space-y-3 text-sm sm:text-base text-slate-200">
              <li>Foundation (Std. 8 - 10)</li>
              <li>Science & Commerce (Std. 11 - 12)</li>
              <li>JEE & NEET Prep</li>
              <li>CA / CS Foundation</li>
              <li>Olympiad Coaching</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 sm:mb-6 text-base sm:text-lg">Quick Links</h4>
            <ul className="space-y-3 text-sm sm:text-base text-slate-200">
              <li>
                <a href="/mv-tutorials/about" className="hover:text-white transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="/mv-tutorials/courses" className="hover:text-white transition-colors">
                  Course Structure
                </a>
              </li>
              <li>
                <a href="/mv-tutorials/results" className="hover:text-white transition-colors">
                  Results
                </a>
              </li>
              <li>
                <a href="/mv-tutorials/resources" className="hover:text-white transition-colors">
                  Study Resources
                </a>
              </li>
              <li>
                <a href="/mv-tutorials/admissions" className="hover:text-white transition-colors">
                  Admissions
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 sm:mb-6 text-base sm:text-lg">Reach Us</h4>
            <div className="space-y-4 mb-6">
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-slate-200 mt-0.5 flex-shrink-0" />
                <p className="text-slate-200 text-sm leading-relaxed">
                  MV Tutorials Building,
                  <br />
                  Mira Road East, Thane 401107
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-slate-200" />
                <span className="text-slate-200 text-sm">+91 99876 54321</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-slate-200" />
                <span className="text-slate-200 text-sm">admissions@mvtutorials.edu</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700/50 mt-8 sm:mt-12 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-xs sm:text-sm text-center sm:text-left">
              © {new Date().getFullYear()} M.V. Tutorials. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-slate-400">
              <a href="#" className="hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Terms of Service
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Alumni Network
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

